<script setup>
const props = defineProps({
  firstKeyword: String,
  secondKeyword: String,
  isMobile:{
    type: Boolean,
    default: false,
  },
})
console.log(props.isMobile)
</script>
<template>
  <div
    class="str-wea-wrapper"
    :class="{mobile: isMobile}"
  >
    <div class="personality-circle primary-blur">
      <span class="circle__main-txt white">
        {{ firstKeyword }}
      </span>
      <span class="circle__sub-txt round white">
        강점
      </span>
    </div>
    <div class="personality-circle black">
      <span class="circle__main-txt black">
        {{ secondKeyword }}
      </span>
      <span class="circle__sub-txt round black">
        발전영역
      </span>
    </div>
  </div>

</template>